import { NSBadge } from 'bricks';
import { getAssetTagById } from 'views/DocumentLibrary/helpers';
import { formatUTCtoLocal } from 'ns_libs/formatter';
import { IProjectAsset } from 'views/DocumentLibrary/types';
import { URLS } from 'services/urls';
import NSTable from '../../../../bricks/NSTable/NSTable';

interface IProjectAssetTableProps {
    projectAssets: IProjectAsset[];
    subprojectId: number;
}

const ProjectAssetTable = ({ projectAssets, subprojectId }: IProjectAssetTableProps) => (
    <NSTable className="p-2">
        <thead className="NSTable__thead">
            <tr className="NSTable__thead__tr">
                <th className="NSTable__thead__tr__th">
                    <div>
                        <span>Name</span>
                    </div>
                </th>
                <th className="NSTable__thead__tr__th">
                    <div>
                        <span>Type</span>
                    </div>
                </th>
                <th className="NSTable__thead__tr__th">
                    <div>
                        <span>Date modified</span>
                    </div>
                </th>
            </tr>
        </thead>
        <tbody>
            {projectAssets?.map(item => (
                <tr
                    key={item.id}
                    className="NSTable__tbody__tr cursor--pointer heap-deal-documents-click-assc-projects-doc"
                    onClick={() => window.open(URLS.PROJECTS_APP.DOCUMENT_LIBRARY(subprojectId, item.directory_id, item.id), '_blank')}
                >
                    <td className="NSTable__tbody__tr__td text-white">{item.name}</td>
                    <td className="NSTable__tbody__tr__td">
                        {item.tags.length > 0 && item.tags.map(tag => (
                            <NSBadge
                                key={tag}
                                color="secondary"
                                className="ml-2"
                            >
                                {getAssetTagById(tag)}
                            </NSBadge>
                        ))}
                    </td>
                    <td className="NSTable__tbody__tr__td text-white">{formatUTCtoLocal(item.updated_at, 'MMM d, yyyy, h:mm a')}</td>
                </tr>
            ))}
        </tbody>
    </NSTable>
);

export default ProjectAssetTable;
